import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import Contact
	from '../list-of-contacts/components/list-of-contacts-body/components/list-of-contacts-body-content/components/contact';
import DirectorySyncModeChoice from './components/directory-sync-mode-choice';
import DirectorySyncAccessDenied from './components/directory-sync-access-denied';
import Loader from '../../../../components/sprite/components/loader';
import './index.css';

function ListOfContactsPreview () {

	const { t } = useTranslation();

	const contacts = useSelector(state => state.contactReducer.findContacts);
	const profile = useSelector(state => state.profileReducer.getProfile);
	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const hasDirectorySyncPermission = useSelector(state => state.permissionReducer.hasDirectorySyncPermission);

	const viewportMarginTop = 10;
	const rowHeight = 84;

	if(contacts){
		if(contacts.contacts.length > 0){
			return (
				<div className="list-of-contacts-preview">
					{
						contacts.contacts.map(item => {
							return (
								<Contact
									key={item.position}
									id={item.id}
									name={item.name}
									email={item.email}
									emails={item.emails}
									hasImage={item.hasImage}
									picture={item.picture}
									phoneNumber={item.phoneNumber}
									jobTitle={item.jobTitle}
									company={item.company}
									labels={item.groups}
									type={item.type}
									shareable={item.shareable}
									editable={item.editable}
									deletable={item.deletable}
									note={item.note}
									totalComments={item.totalComments}
									previewMode={true}
									rowStyle={{height: rowHeight, top: item.position * rowHeight - rowHeight + viewportMarginTop}}
								/>
							)
						})
					}
					{
						profile.isAdmin &&
						hasDirectorySyncPermission
							?
								<DirectorySyncModeChoice/>
							:
								<DirectorySyncAccessDenied
									selectedContactsGroup={selectedContactsGroup}
									profile={profile}
								/>
					}
				</div>
			)
		} else {
			return (
				<div className="list-of-contacts-preview p-3">
					<p>{t("noContactText")}</p>
					{
						profile.isAdmin &&
						hasDirectorySyncPermission
							?
							<DirectorySyncModeChoice/>
							:
							<DirectorySyncAccessDenied
								selectedContactsGroup={selectedContactsGroup}
								profile={profile}
							/>
					}
				</div>
			)
		}
	} else {
		return (
			<div className="list-of-contacts-preview p-3">
				<Loader/>
			</div>
		)
	}

}

export default ListOfContactsPreview;
